// extracted by mini-css-extract-plugin
var _1 = "Labels-modulerightMargin__wOz3g";
export { _1 as "rightMargin" }
